/**
 * Microsoft Clarity Enhanced Tracking
 * 
 * This module provides comprehensive tracking for user interactions
 */

/**
 * Track custom event
 */
export function trackEvent(eventName, data = {}) {
    if (typeof window.clarity !== 'undefined') {
        window.clarity("event", eventName, data);
        console.log('Clarity Event:', eventName, data);
    }
}

/**
 * Identify user for Clarity
 */
export function identifyUser(user) {
    if (!user || typeof window.clarity === 'undefined') return;
    
    window.clarity("identify", user.id.toString(), {
        userType: user.is_page ? 'page' : 'user',
        userName: user.user_name,
        name: user.name,
        verified: user.is_verify || false,
        hasParent: !!user.parent_user_id
    });
    
    // Set custom session tags
    window.clarity("set", "user_type", user.is_page ? 'page' : 'user');
    window.clarity("set", "verified", user.is_verify ? 'yes' : 'no');
    
    //console.log('Clarity: User identified', user.user_name);
}

/**
 * Track page view
 */
export function trackPageView(pageName, metadata = {}) {
    trackEvent('page_view', {
        page: pageName,
        ...metadata
    });
}

/**
 * Track user registration
 */
export function trackRegistration(user, parentId = null) {
    trackEvent('user_registration', {
        userId: user.id,
        userName: user.user_name,
        hasParent: !!parentId,
        parentId: parentId
    });
}

/**
 * Track user login
 */
export function trackLogin(userId) {
    trackEvent('user_login', {
        userId: userId
    });
}

/**
 * Track post interaction
 */
export function trackPostInteraction(action, postId, postAuthor) {
    trackEvent(`post_${action}`, {
        postId: postId,
        postAuthor: postAuthor,
        action: action
    });
}

/**
 * Track follow action
 */
export function trackFollow(targetUserId, targetUserName, action) {
    trackEvent(`user_${action}`, {
        targetUserId: targetUserId,
        targetUserName: targetUserName,
        action: action
    });
}

/**
 * Track search
 */
export function trackSearch(query, resultsCount) {
    trackEvent('search', {
        query: query,
        resultsCount: resultsCount
    });
}

/**
 * Track form submission
 */
export function trackFormSubmit(formName, success = true) {
    trackEvent('form_submit', {
        formName: formName,
        success: success
    });
}

/**
 * Track error
 */
export function trackError(errorType, errorMessage) {
    trackEvent('error', {
        errorType: errorType,
        errorMessage: errorMessage
    });
}

/**
 * Track modal open
 */
export function trackModalOpen(modalName) {
    trackEvent('modal_open', {
        modalName: modalName
    });
}

/**
 * Track navigation
 */
export function trackNavigation(from, to) {
    trackEvent('navigation', {
        from: from,
        to: to
    });
}

/**
 * Track conversion (e.g., signup bonus claimed, subscription purchased)
 */
export function trackConversion(conversionType, value = null) {
    trackEvent('conversion', {
        type: conversionType,
        value: value
    });
}

/**
 * Track MLM network action
 */
export function trackMLM(action, data = {}) {
    trackEvent(`mlm_${action}`, {
        action: action,
        ...data
    });
}

/**
 * Track newspaper/article interaction
 */
export function trackNewsInteraction(action, articleId, newspaperId) {
    trackEvent(`news_${action}`, {
        articleId: articleId,
        newspaperId: newspaperId,
        action: action
    });
}

